export var LOCAL_STORAGE_MESSAGES = '__statist_saved_messages';
export var LOCAL_STORAGE_DISABLED_GZIP = '_statist_disable_gzip';
export var LOCAL_STORAGE_ENABLED_GZIP = '_statist_enable_gzip';
//# sourceMappingURL=labels.js.map